// Automatically compiles all the files from '/components' using Webpack Mix (https://laravel.com/docs/8.x/mix).

import $ from 'jquery'
window.jQuery = window.$ = $
import 'jquery-match-height'

const req = require.context('./components/', true, /\.(js)$/i)
req.keys().map(key => { req(key).default() })